<template>
  <div>
    <!-- Button to toggle offcanvas -->
    <button
      class="btn btn-outline-light"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#activityInstructions"
      aria-controls="activityInstructions"
    >
      <span class="bi bi-info-circle"></span>
      Instructions
    </button>

    <!-- Offcanvas -->
    <div
      class="offcanvas offcanvas-end text-start text-wrap"
      tabindex="-1"
      id="activityInstructions"
      aria-labelledby="activityInstructionsLabel"
    >
      <div class="offcanvas-header">
        <h1 class="offcanvas-title h3" id="activityInstructionsLabel">
          Activity Instructions
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <p class="fw-semibold">
          Use sliders or text boxes to adjust parameters:
        </p>
        <ul>
          <li>Albedo: Reflectivity of the planet.</li>
          <li>Distance from Sun (A.U.): Distance from the Sun.</li>
          <li>Solar Intensity (%): Energy output from the Sun.</li>
          <li>Greenhouse Effect: Strength of heat trapping.</li>
          <li>Surface Temperature: Toggle between °C and °F.</li>
        </ul>

        <p class="fw-semibold">Observe:</p>
        <ul>
          <li>Visualization updates based on parameters.</li>
          <li>Energy bars for incoming and outgoing radiation.</li>
        </ul>

        <p class="fw-semibold">
          Experiment and discover how planets achieve energy balance:
        </p>
        <ul>
          <li>
            Adjust parameters to bring the net radiant energy close to zero.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityInstructions"
};
</script>

<style scoped>
.offcanvas {
  width: 500px !important;
}
</style>
